import { useLang } from '@/i18n';
import EFXStream from 'elem/ui-assets/icons/unregular/EFXStream';
import EfSection from '@elem/ui/ef-section';
import EfSpec from '@elem/ui/ef-spec';
import styles from './index.module.scss';

const locale = 'mx';

export default function TheComp() {
    const { t } = useLang('delta3series');


    //缺少h5和pad图，暂时用pc图代替 
    const items = [
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1775285018933/6-pc.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1775285018933/6-pc.jpg',
            title: t.rich('NA4_item1_title', {
                b: (tx: string) => <span className="b">{tx}</span>,
                sup: (tx: string) => <sup className="sup">{tx}</sup>,
            }),
            desc: t('NA4_item1_desc'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1775285018754/7-pc.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1775285018754/7-pc.jpg',
            title: t.rich('NA4_item2_title', {
                b: (tx: string) => <span className="b">{tx}</span>,
                sup: (tx: string) => <sup className="sup">{tx}</sup>,
            }),
            desc: t('NA4_item2_desc'),
        },
    ];

    return (
        <div className={`${styles.TheComp} GtmModuleData-section`} data-section-id="D3-NA4" id='D3-NA4'>
            <EfSpec className="spec-m" />
            <ul className="items">
                {items.map((item: any, k: number) => (
                    <div key={k} id={`D3-NA4-${k + 1}`}>
                        {k !== 0 && <EfSpec className="spec-m" />}
                        {k === 0 && <EFXStream className="logo" />}
                        <EfSection {...item} hasAnimation={false} />
                    </div>
                ))}
            </ul>
        </div>
    );
}
